const KEY = "sf_profile";

export const getProfile = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "{}"); }
  catch { return {}; }
};

export const saveProfile = (p) => {
  const clean = {
    guest_name: (p.guest_name || "").trim(),
    guest_email: (p.guest_email || "").trim(),
    guest_phone: (p.guest_phone || "").trim(),
  };
  localStorage.setItem(KEY, JSON.stringify(clean));
  window.dispatchEvent(new Event("sf-profile"));
  return clean;
};

export const hasProfile = () => {
  const p = getProfile();
  return Boolean(p.guest_name || p.guest_email || p.guest_phone);
};
